import {PlayerBase} from "../../player/player.base";
import {Component, Injector} from '@angular/core';
import {GenericElm} from '../../player/generic.elm';
import {interval, mergeMap, mergeWith, Observable, of, switchMap, takeUntil} from 'rxjs';
import {catchError, delay, repeat, tap} from "rxjs/operators";



@Component({
  selector: 'app-countdown',
  template: '<div #component></div>',
  styleUrls: []
})
export class CountdownComponent extends PlayerBase {
  genericElm: GenericElm;
  mode;
  formatText;
  finalDate: Date;
  duration: number;
  playTime: number;

  constructor(protected  injector: Injector) {
    super(injector);
  }

  load(playerObject: any): Observable<any> {
    let self;
    return super.load(playerObject).pipe(
      switchMap( playerBase => {
        self = playerBase;
        if (this.genericElm==null) {
          this.genericElm = new GenericElm(this.component);
        }

        const font = this.data.Countdown[0].Font[0].$;
        this.genericElm.fontStyle = this.getFontStyle(font);

        this.formatText = this.data.Countdown[0].$.formatText;
        this.mode = this.data.Countdown[0].$.mode;

        this.finalDate = new Date();
        const time = Number(this.data.Countdown[0].$.finalDate);


        if (this.mode == "Date") {
          this.finalDate.setTime(time);
        } else {
          this.duration = Number(this.data.Countdown[0].$.duration);
          this.playTime = new Date().getTime();
        }

        return this.playerService.caching.requestFont(font);
      }),
      switchMap(a => {
        if (this.editMode) {
          this.genericElm.setText(this.formatText);
        }
        return of('a');
      }),
      catchError( err => this.logError(err) ),
      switchMap(a => of(self)),
      takeUntil(this.finish$)
    )
  }

  play(): Observable<any> {
    if (this.editMode) {
      return of(null);
    }
    return super.play().pipe(
      mergeWith(
        of('clock').pipe(
          switchMap( a => this.showTime() ),
          delay(1000),
          repeat()
        )
      )

    )
  }



  showTime() {
    let time = 0;
    if (this.mode=="Date")
    {
      let date:Date = new Date();
      time = Math.max(0, (this.finalDate.getTime() - date.getTime())/1000);
    }
    else
    {
      const running = (new Date().getTime() - this.playTime) / 1000;
      time = Math.max(0, this.duration - running);
    }
    let seconds:number = Math.floor(time % 60);
    time/=60;
    let minuts:number = Math.floor(time % 60);
    time/=60;
    let hours:number = Math.floor(time % 24);
    let days:number = Math.floor(time/24);
    let str = this.formatText;
    str = str.replace(/%D/g, days.toString());
    str = str.replace(/%H/g, hours.toString());
    str = str.replace(/%M/g, ((minuts<10) ? "0" : "") + minuts.toString());
    str = str.replace(/%S/g, ((seconds<10) ? "0" : "") + seconds.toString());


    this.genericElm.setText(str);
    return of('time');
  }

  destroy(): void {
    if (this.genericElm != null) {
      this.genericElm.destroy();
    }
    super.destroy();
  }
}
